import axios from "axios";
import { useMainStore } from "@/stores";
import { toastAiQuota, toastApiError } from "@/shared/utils/toast";

/** Bulk LLM routes opt out of the default with an explicit timeout. */
export const LONG_REQUEST_TIMEOUT_MS = 900_000;

const axiosInstanceAI = axios.create({
  baseURL: process.env.REACT_APP_AI_BASE_URL,
  // axios defaults to no timeout, so a hung ai_backend call never resolved.
  timeout: 120_000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to add token to Authorization header
axiosInstanceAI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const { user } = useMainStore.getState();
    if (user?.organization_id) {
      config.headers["X-Tenant-Id"] = user.organization_id;
    }

    // For FormData, remove default Content-Type
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstanceAI.interceptors.response.use(
  toastAiQuota,
  (err) => {
    toastApiError(
      err,
      err?.response?.status === 503
        ? "Something went wrong from our side. Please try again after sometime."
        : undefined,
    );
    return Promise.reject(err);
  },
);

export default axiosInstanceAI;
